/**
 * Video over a Tools & Equipment step photo (snippets/scroll-step-photo.liquid, .step-video).
 * - Tablets and larger only: below 768px (phones) the video is never downloaded and the photo stays.
 * - The photo stays visible until the first frame plays, then the video fades in over it.
 * - Skipped (the photo stays) for visitors who prefer reduced motion or when the browser refuses autoplay.
 * - Only plays while it is on screen and, in the pinned layout, while its step is the active one.
 */
(() => {
  const videos = [...document.querySelectorAll('[data-step-video]')];
  if (!videos.length) return;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const phone = window.matchMedia('(max-width: 767px)');

  videos.forEach((video) => {
    if (reduce) {
      video.remove();
      return;
    }
    video.muted = true;
    // Optional slower playback (data-rate, e.g. 0.6); re-applied once the file has loaded.
    const rate = parseFloat(video.dataset.rate) || 1;
    const applyRate = () => (video.playbackRate = rate);
    applyRate();
    video.addEventListener('loadedmetadata', applyRate);
    video.addEventListener('playing', applyRate, { once: true });
    let onScreen = false;
    const visual = video.closest('[data-visual]');
    video.addEventListener('playing', () => video.classList.add('is-playing'), { once: true });

    const update = () => {
      if (!video.isConnected) return;
      const active = !visual || visual.classList.contains('is-active');
      if (phone.matches || document.hidden || !onScreen || !active) {
        video.pause();
        return;
      }
      if (!video.getAttribute('src')) video.src = video.dataset.src;
      const attempt = video.play();
      if (attempt && attempt.catch) attempt.catch(() => video.remove());
    };

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        (entries) => {
          onScreen = entries.some((entry) => entry.isIntersecting);
          update();
        },
        { threshold: 0 }
      ).observe(video);
    }
    if (visual) new MutationObserver(update).observe(visual, { attributes: true, attributeFilter: ['class'] });
    document.addEventListener('visibilitychange', update);
    phone.addEventListener('change', update);
  });
})();
